/*
  Legacy World — Completar la orden por WhatsApp
  assets/lg-whatsapp.js

  1. En el carrito y en la ventana "Añadir al carrito" muestra el botón
     "Completar la orden por WhatsApp".
  2. Abre una ventana de cristal donde el cliente pone sus datos:
     nombre, cédula, teléfono, entrega, dirección/ubicación y método de pago.
  3. Lee el carrito real en ese momento y abre WhatsApp con el pedido completo.

  ─────────── CONFIGURACIÓN (edita solo esta parte) ───────────
*/
window.LG_WA_CONFIG = window.LG_WA_CONFIG || {
  phone: '584128211464',                 /* Número de WhatsApp, sin + ni espacios */
  payments: ['Pago Móvil', 'Transferencia en bolívares', 'Zelle', 'Efectivo en dólares', 'Binance'],
  deliveries: [
    { id: 'caracas', label: 'Delivery en Caracas (gratis)', needs: 'address' },
    { id: 'pickup',  label: 'Retiro en Caracas (gratis)',  needs: 'none' },
    { id: 'national', label: 'Envío nacional', needs: 'agency' }
  ],
  carriers: ['MRW', 'Zoom', 'Tealca'],   /* Empresas de envío nacional */
  freeShippingFrom: 150,                 /* Envío gratis desde (USD). 0 para ocultar la barra */
  bcvNote: 'Si pagas en bolívares, el monto se calcula a la tasa oficial del BCV del día.'
};
/* ─────────────────────────────────────────────────────────────── */

(function () {
  if (window.__lgWaLoaded) return;
  window.__lgWaLoaded = true;

  var C = window.LG_WA_CONFIG;
  var STORE_KEY = 'lg-wa-customer';
  var WA_ICON = '<svg viewBox="0 0 24 24" aria-hidden="true"><path fill="currentColor" d="M12 2a10 10 0 0 0-8.6 15.1L2 22l5-1.3A10 10 0 1 0 12 2zm0 18.2c-1.6 0-3.1-.4-4.4-1.2l-.3-.2-3 .8.8-2.9-.2-.3A8.2 8.2 0 1 1 12 20.2zm4.5-6.1c-.2-.1-1.5-.7-1.7-.8-.2-.1-.4-.1-.6.1l-.8 1c-.1.2-.3.2-.5.1a6.7 6.7 0 0 1-3.3-2.9c-.2-.4.2-.4.7-1.3.1-.2 0-.3 0-.4l-.8-1.8c-.2-.5-.4-.4-.6-.4h-.5c-.2 0-.4.1-.6.3-.2.2-.8.8-.8 2s.8 2.3.9 2.5c.1.2 1.6 2.5 4 3.5 1.5.6 2.1.7 2.8.6.5-.1 1.5-.6 1.7-1.2.2-.6.2-1.1.1-1.2l-.5-.3z"/></svg>';

  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }
  function load() {
    try { return JSON.parse(localStorage.getItem(STORE_KEY)) || {}; } catch (e) { return {}; }
  }
  function save(data) {
    try { localStorage.setItem(STORE_KEY, JSON.stringify(data)); } catch (e) {}
  }

  /* ---------- Ventana de cristal ---------- */
  var dlg;
  function buildDialog() {
    if (dlg) return dlg;
    dlg = document.createElement('dialog');
    dlg.className = 'lg-wa';
    dlg.setAttribute('aria-labelledby', 'lg-wa-title');
    var d = load();
    var opts = function (arr, sel) {
      return arr.map(function (o) {
        var v = typeof o === 'string' ? o : o.id;
        var l = typeof o === 'string' ? o : o.label;
        return '<option value="' + esc(v) + '"' + (sel === v ? ' selected' : '') + '>' + esc(l) + '</option>';
      }).join('');
    };
    dlg.innerHTML =
      '<form class="lg-wa__panel" method="dialog" novalidate>' +
        '<button type="button" class="lg-wa__close" aria-label="Cerrar" data-lg-wa-close>×</button>' +
        '<p class="lg-wa__step">Último paso</p>' +
        '<h2 id="lg-wa-title" class="lg-wa__title">Completa tu orden por WhatsApp</h2>' +
        '<p class="lg-wa__sub">Llena tus datos y te llegará el pedido listo para confirmar.</p>' +

        '<div class="lg-wa__summary" data-lg-wa-summary><span class="lg-wa__loading">Cargando tu carrito…</span></div>' +

        '<fieldset class="lg-wa__group"><legend>Tus datos</legend>' +
          '<label class="lg-wa__field"><span>Nombre y apellido</span><input name="name" required autocomplete="name" value="' + esc(d.name) + '"></label>' +
          '<div class="lg-wa__row">' +
            '<label class="lg-wa__field"><span>Cédula</span><input name="id" required inputmode="numeric" placeholder="V-12345678" value="' + esc(d.id) + '"></label>' +
            '<label class="lg-wa__field"><span>Teléfono</span><input name="phone" required type="tel" autocomplete="tel" placeholder="0412 1234567" value="' + esc(d.phone) + '"></label>' +
          '</div>' +
          '<label class="lg-wa__field"><span>Correo electrónico</span><input name="email" required type="email" autocomplete="email" placeholder="tu@correo.com" value="' + esc(d.email || (window.LG_CUSTOMER_EMAIL || '')) + '"></label>' +
        '</fieldset>' +

        '<fieldset class="lg-wa__group"><legend>Entrega</legend>' +
          '<div class="lg-wa__chips" role="radiogroup">' +
            C.deliveries.map(function (o, i) {
              var checked = d.delivery ? d.delivery === o.id : i === 0;
              return '<label class="lg-wa__chip"><input type="radio" name="delivery" value="' + esc(o.id) + '"' + (checked ? ' checked' : '') + '><span>' + esc(o.label) + '</span></label>';
            }).join('') +
          '</div>' +
          '<div data-need="address">' +
            '<label class="lg-wa__field"><span>Dirección de entrega</span><textarea name="address" rows="2" placeholder="Urbanización, calle, edificio, piso, punto de referencia">' + esc(d.address) + '</textarea></label>' +
            '<button type="button" class="lg-wa__geo" data-lg-wa-geo>📍 Compartir mi ubicación</button>' +
            '<input type="hidden" name="maps" value="' + esc(d.maps) + '">' +
            '<p class="lg-wa__geo-ok" data-lg-wa-geo-ok' + (d.maps ? '' : ' hidden') + '>Ubicación agregada ✓</p>' +
          '</div>' +
          '<div data-need="agency">' +
            '<div class="lg-wa__row">' +
              '<label class="lg-wa__field"><span>Empresa de envío</span><select name="carrier">' + opts(C.carriers, d.carrier) + '</select></label>' +
              '<label class="lg-wa__field"><span>Estado y ciudad</span><input name="city" placeholder="Carabobo, Valencia" value="' + esc(d.city) + '"></label>' +
            '</div>' +
            '<label class="lg-wa__field"><span>Agencia o dirección</span><input name="agency" placeholder="Nombre o código de la agencia" value="' + esc(d.agency) + '"></label>' +
          '</div>' +
        '</fieldset>' +

        '<fieldset class="lg-wa__group"><legend>Pago</legend>' +
          '<div class="lg-wa__chips" role="radiogroup">' +
            C.payments.map(function (p, i) {
              var checked = d.payment ? d.payment === p : i === 0;
              return '<label class="lg-wa__chip"><input type="radio" name="payment" value="' + esc(p) + '"' + (checked ? ' checked' : '') + '><span>' + esc(p) + '</span></label>';
            }).join('') +
          '</div>' +
          '<p class="lg-wa__note">' + esc(C.bcvNote) + '</p>' +
        '</fieldset>' +

        '<label class="lg-wa__field"><span>Notas (opcional)</span><input name="notes" placeholder="Algo que debamos saber" value=""></label>' +

        '<p class="lg-wa__error" data-lg-wa-error hidden></p>' +
        '<button type="submit" class="lg-wa-btn lg-wa__send">' + WA_ICON + '<span>Enviar pedido por WhatsApp</span></button>' +
        '<p class="lg-wa__legal">Al enviar, se abrirá WhatsApp con tu pedido. Lo confirmamos contigo por chat antes de cobrarte.</p>' +
      '</form>';
    document.body.appendChild(dlg);

    var form = dlg.querySelector('form');
    function toggleNeeds() {
      var sel = form.querySelector('[name="delivery"]:checked');
      var need = 'none';
      C.deliveries.forEach(function (o) { if (sel && o.id === sel.value) need = o.needs; });
      form.querySelectorAll('[data-need]').forEach(function (el) {
        el.hidden = el.getAttribute('data-need') !== need;
      });
    }
    form.addEventListener('change', toggleNeeds);
    toggleNeeds();

    dlg.addEventListener('click', function (e) {
      if (e.target === dlg || e.target.closest('[data-lg-wa-close]')) dlg.close();
    });

    form.querySelector('[data-lg-wa-geo]').addEventListener('click', function (e) {
      var btn = e.currentTarget;
      if (!navigator.geolocation) return;
      btn.textContent = 'Buscando ubicación…';
      navigator.geolocation.getCurrentPosition(function (pos) {
        var url = 'https://maps.google.com/?q=' + pos.coords.latitude.toFixed(6) + ',' + pos.coords.longitude.toFixed(6);
        form.maps.value = url;
        btn.textContent = '📍 Actualizar ubicación';
        form.querySelector('[data-lg-wa-geo-ok]').hidden = false;
      }, function () {
        btn.textContent = '📍 No pudimos obtenerla. Escribe tu dirección';
      }, { enableHighAccuracy: true, timeout: 10000 });
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      send(form);
    });
    return dlg;
  }

  /* ---------- Resumen del carrito dentro de la ventana ---------- */
  function renderSummary(cart) {
    var box = dlg.querySelector('[data-lg-wa-summary]');
    if (!cart.item_count) {
      box.innerHTML = '<span class="lg-wa__loading">Tu carrito está vacío.</span>';
      return;
    }
    var html = cart.items.map(function (it) {
      var img = it.image ? it.image.replace(/(\.[a-z]+)(\?|$)/i, '_120x$1$2') : '';
      return '<div class="lg-wa__item">' +
        (img ? '<img src="' + esc(img) + '" alt="" width="48" height="48">' : '') +
        '<div><strong>' + esc(it.product_title) + '</strong>' +
        (it.variant_title ? '<span>' + esc(it.variant_title) + ' · x' + it.quantity + '</span>' : '<span>x' + it.quantity + '</span>') +
        '</div><b>' + money(it.final_line_price) + '</b></div>';
    }).join('');
    var discount = cart.total_discount ? '<div class="lg-wa__line"><span>Descuento</span><span>−' + money(cart.total_discount) + '</span></div>' : '';
    var free = '';
    if (C.freeShippingFrom) {
      var left = C.freeShippingFrom * 100 - cart.total_price;
      var pct = Math.min(100, Math.round(cart.total_price / (C.freeShippingFrom * 100) * 100));
      free = '<div class="lg-wa__ship">' + (left > 0 ? 'Te faltan <b>' + money(left) + '</b> para el envío nacional gratis' : '¡Tienes envío nacional gratis! 🎉') +
        '<div class="lg-wa__bar"><i style="width:' + pct + '%"></i></div></div>';
    }
    box.innerHTML = html + discount + '<div class="lg-wa__line lg-wa__total"><span>Total</span><span>' + money(cart.total_price) + '</span></div>' + free;
  }

  function fetchCart() {
    return fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function open() {
    buildDialog();
    if (!dlg.open) dlg.showModal();
    fetchCart().then(renderSummary).catch(function () {});
  }

  /* ---------- Armar y enviar el mensaje ---------- */
  function send(form) {
    var f = form.elements;
    var err = form.querySelector('[data-lg-wa-error]');
    var delivery = form.querySelector('[name="delivery"]:checked');
    var dConf = C.deliveries.filter(function (o) { return delivery && o.id === delivery.value; })[0] || {};
    var missing = [];
    if (!f.name.value.trim()) missing.push('nombre');
    if (!f.id.value.trim()) missing.push('cédula');
    if (!f.phone.value.trim()) missing.push('teléfono');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email.value.trim())) missing.push('correo válido');
    if (dConf.needs === 'address' && !f.address.value.trim() && !f.maps.value) missing.push('dirección o ubicación');
    if (dConf.needs === 'agency' && (!f.city.value.trim() || !f.agency.value.trim())) missing.push('ciudad y agencia');
    if (missing.length) {
      err.textContent = 'Falta: ' + missing.join(', ') + '.';
      err.hidden = false;
      return;
    }
    err.hidden = true;

    var payment = form.querySelector('[name="payment"]:checked');
    var data = {
      name: f.name.value.trim(), id: f.id.value.trim(), phone: f.phone.value.trim(), email: f.email.value.trim(),
      delivery: delivery.value, address: f.address.value.trim(), maps: f.maps.value,
      carrier: f.carrier.value, city: f.city.value.trim(), agency: f.agency.value.trim(),
      payment: payment ? payment.value : ''
    };
    save(data);

    /* Abrimos la pestaña ya (evita bloqueo de pop-ups en iPhone) y luego le ponemos el enlace */
    var win = window.open('', '_blank');

    fetchCart().then(function (cart) {
      var L = [];
      L.push('Hola Legacy World 👋 Quiero completar esta orden:');
      L.push('');
      L.push('🛍️ *PEDIDO*');
      cart.items.forEach(function (it) {
        L.push('• ' + it.product_title + (it.variant_title ? ' (' + it.variant_title + ')' : '') + ' x' + it.quantity + ' — ' + money(it.final_line_price));
      });
      if (cart.total_discount) {
        var codes = (cart.cart_level_discount_applications || []).concat(
          [].concat.apply([], cart.items.map(function (i) { return i.line_level_discount_allocations || []; }))
            .map(function (a) { return a.discount_application; })
        ).map(function (a) { return a && a.title; }).filter(Boolean);
        codes = codes.filter(function (c, i) { return codes.indexOf(c) === i; });
        L.push('Descuento' + (codes.length ? ' (' + codes.join(', ') + ')' : '') + ': −' + money(cart.total_discount));
      }
      L.push('*Total: ' + money(cart.total_price) + '*');
      L.push('');
      L.push('👤 *DATOS*');
      L.push('Nombre: ' + data.name);
      L.push('Cédula: ' + data.id);
      L.push('Teléfono: ' + data.phone);
      L.push('Correo: ' + data.email);
      L.push('');
      L.push('🚚 *ENTREGA*');
      L.push(dConf.label || data.delivery);
      if (dConf.needs === 'address') {
        if (data.address) L.push('Dirección: ' + data.address);
        if (data.maps) L.push('Ubicación: ' + data.maps);
      }
      if (dConf.needs === 'agency') {
        L.push('Empresa: ' + data.carrier);
        L.push('Ciudad: ' + data.city);
        L.push('Agencia: ' + data.agency);
      }
      L.push('');
      L.push('💳 *PAGO*');
      L.push(data.payment);
      if (f.notes.value.trim()) {
        L.push('');
        L.push('📝 Notas: ' + f.notes.value.trim());
      }
      var url = 'https://wa.me/' + C.phone + '?text=' + encodeURIComponent(L.join('\n'));
      if (win) win.location.href = url; else window.location.href = url;
      dlg.close();
    }).catch(function () {
      if (win) win.close();
      err.textContent = 'No pudimos leer tu carrito. Recarga la página e inténtalo de nuevo.';
      err.hidden = false;
    });
  }

  /* ---------- Botón "Completar la orden por WhatsApp" en producto / Añadir al carrito ----------
     El botón lo dibuja el tema (blocks/buy-buttons.liquid). Aquí solo añadimos
     el producto con la talla elegida y abrimos el formulario. */
  function updateBubble(count) {
    document.querySelectorAll('.cart-bubble').forEach(function (b) {
      b.classList.toggle('visually-hidden', !count);
      var t = b.querySelector('.cart-bubble__text-count');
      if (t) t.textContent = count;
    });
  }

  function addThenOpen(btn) {
    var scope = btn.parentElement;
    var form = scope && scope.querySelector('form[action*="/cart/add"]');
    if (!form) { open(); return; }
    btn.disabled = true;
    fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: new FormData(form)
    }).then(function (r) {
      return r.json().then(function (j) { if (!r.ok) throw j; return j; });
    }).then(function () {
      var qa = btn.closest('dialog');
      if (qa && qa.open) qa.close();
      open();
      fetchCart().then(function (c) { updateBubble(c.item_count); }).catch(function () {});
    }).catch(function (e) {
      alert((e && (e.description || e.message)) || 'No se pudo agregar el producto.');
    }).finally(function () { btn.disabled = false; });
  }

  /* ---------- Clics ---------- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-lg-wa-open]');
    if (openBtn) { e.preventDefault(); open(); return; }
    var addBtn = e.target.closest('[data-lg-wa-add]');
    if (addBtn) { e.preventDefault(); addThenOpen(addBtn); }
  });

})();
